export default "__VITE_ASSET__7ab0f73d__"